import axios from '@/helpers/axios'

const initialState = {
  data: []
}

const mutations = {
  setData(state, payload = []) {
    state.data = payload
  },
}

const actions = {
  get({ commit }) {
    return axios.get(`${process.env.VUE_APP_LIVE_DETECTION_REVIEWS_API_URL}/annotations/available_tasks_count/`)
      .then(({ data: { data } }) => commit('setData', data))
  },
}

export default {
  namespaced: true,
  state: { ...initialState },
  actions,
  mutations
}